import { render } from "./headerFacture.vue?vue&type=template&id=61b73576"
import script from "./headerFacture.vue?vue&type=script&lang=ts"
export * from "./headerFacture.vue?vue&type=script&lang=ts"
script.render = render

export default script